import React from 'react';
import PropTypes from 'prop-types';

import { FloatGroup, Input, Card, FlexBinaryChoiceRow, FormCardSpaced, ColorPickerInput, Typography } from 'modules/common';

import { getAmountNudgeMaximumAmountDefault } from '../tools';

function WidgetAmountNudge({ widget, updateWidget, disabled = false, isPartOfUpsell = false }) {
  return (
    <div className="widget-amount-nudge">
      <div className="mt-3">
        <Card.Title>Nudge Popup Body Copy</Card.Title>
        <Typography>Add some copy to your amount nudge widget to encourage donors to select a higher donation amount. 200 character maximum</Typography>
        <Input
          type="text"
          placeholder="Supporters like you power this movement. Can you increase your gift to the next level?"
          value={widget.amountNudgeMessage || ''}
          disabled={disabled}
          name="amountNudgeMessage"
          onChange={updateWidget}
          maxLength={200}
        />
      </div>

      <div className="mt-3">
        <Card.Title>Nudge Popup Container Color</Card.Title>
        <Typography>The color of the popup container.</Typography>
        <ColorPickerInput
          name="amountNudgeContainerColor"
          value={widget.amountNudgeContainerColor || '#FFCD84'}
          setColorAction={updateWidget}
          disabled={disabled}
        />
      </div>

      <div className="mt-3">
        <Card.Title>Text Color</Card.Title>
        <Typography>The color of the text within the popup container.</Typography>
        <ColorPickerInput
          name="amountNudgeContainerTextColor"
          value={widget.amountNudgeContainerTextColor || '#191E2A'}
          setColorAction={updateWidget}
          disabled={disabled}
        />
      </div>

      <div className="mt-3">
        <Card.Title>Maximum Nudge Amount</Card.Title>
        <Typography>This widget will be hidden from donors who select an amount greater than or equal to this value.</Typography>
        <FloatGroup className="prepend-label-dollar">
          <Input
            moneyInput
            prepend="$"
            disabled={disabled}
            placeholder="Maximum Nudge Amount"
            name="amountNudgeMaximumAmount"
            value={widget.amountNudgeMaximumAmount || getAmountNudgeMaximumAmountDefault(isPartOfUpsell)}
            onChange={updateWidget}
          />
        </FloatGroup>
      </div>

      <FormCardSpaced
        className="mb-3 mt-3"
        classNameFooter="bg-catskill-white"
        footer={
          widget.amountNudgeShowAcceptMessage ? (
            <>
              <FormCardSpaced>
                <div className="mt-3">
                  <Card.Title>Nudge Popup Accepted Copy</Card.Title>
                  <Typography>Add a message to your popup widget that will display when donors select the encouraged amount. 200 character maximum</Typography>
                  <Input
                    type="text"
                    placeholder="Thank you for stepping up! Your support truly makes a difference."
                    value={widget.amountNudgeAcceptMessage || ''}
                    disabled={disabled}
                    name="amountNudgeAcceptMessage"
                    onChange={updateWidget}
                    maxLength={200}
                  />
                </div>
              </FormCardSpaced>

              <FormCardSpaced>
                <div className="mt-3">
                  <Card.Title>Accept Popup Container Color</Card.Title>
                  <Typography>The color of the popup container once the encouraged amount is met.</Typography>
                  <ColorPickerInput
                    name="amountNudgeAcceptContainerColor"
                    value={widget.amountNudgeAcceptContainerColor || '#8DD1A4'}
                    setColorAction={updateWidget}
                    disabled={disabled}
                  />
                </div>
              </FormCardSpaced>

              <FormCardSpaced>
                <div className="mt-3">
                  <Card.Title>Accept Text Color</Card.Title>
                  <Typography>The color of the text within the accept popup container.</Typography>
                  <ColorPickerInput
                    name="amountNudgeAcceptContainerTextColor"
                    value={widget.amountNudgeAcceptContainerTextColor || '#191E2A'}
                    setColorAction={updateWidget}
                    disabled={disabled}
                  />
                </div>
              </FormCardSpaced>
            </>
          ) : null
        }
      >
        <FlexBinaryChoiceRow
          name="amountNudgeShowAcceptMessage"
          title="Add Accept Message"
          disabled={disabled}
          subTitle="Toggle Yes to change the amount nudge widget's color and display an acceptance message when donors select the encouraged amount."
          value={widget.amountNudgeShowAcceptMessage}
          onChange={updateWidget}
        />
      </FormCardSpaced>
    </div>
  );
}

WidgetAmountNudge.propTypes = {
  widget: PropTypes.object.isRequired,
  updateWidget: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isPartOfUpsell: PropTypes.bool,
};

export default WidgetAmountNudge;

